import { Component, Input, inject } from '@angular/core'
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { WolseleyStockCheckComponent } from '../wolseley-stock-check/wolseley-stock-check.component'

@Component({
    selector: 'sf-wolseley-stock-check-offcanvas',
    imports: [WolseleyStockCheckComponent, ButtonComponent],
    templateUrl: './wolseley-stock-check-offcanvas.component.html',
    styleUrl: './wolseley-stock-check-offcanvas.component.scss',
})
export class WolseleyStockCheckOffcanvasComponent {
    activeOffcanvas: NgbActiveOffcanvas = inject(NgbActiveOffcanvas)

    @Input() productCodes: { productCode: string; quantity: number }[] = []

    dismiss(): void {
        this.activeOffcanvas.dismiss()
    }
    close(): void {
        this.activeOffcanvas.close()
    }
}
